import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { IoIosSearch } from 'react-icons/io';

import styles from './SearchConversation.scss';

export default function SearchConversation({ className, value, placeholder, onChange }) {
    return (
        <div className={cn(styles.root, className)}>
            <IoIosSearch size={20} color="#8E8E93" className={styles.icon} />
            <input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className={styles.input}
            />
        </div>
    );
}

SearchConversation.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
};

SearchConversation.defaultProps = {
    value: '',
};
